export default __webpack_public_path__ + "44a05c0359129547d18aa5f44826958d.woff2";